import React, { Component } from 'react';

// Componente nuevo: Semáforo de Votaciones
// TODO: completar fechas y confirmar sentido de cada voto con las actas de Cabildo

class SemaforoVotaciones extends Component {
    constructor(props){
        super(props);
        this.state = {
            votos: [
                {
                    id: 1,
                    tema: 'Modificación al artículo 127 del Reglamento Interior del Ayuntamiento',
                    voto: 'A Favor',
                    color: 'verde',
                    motivo: 'Fortalece los mecanismos de acceso a la información y rendición de cuentas.',
                    fecha: 'Consultar acta de Cabildo'
                },
                {
                    id: 2,
                    tema: 'Priorización de recursos para alumbrado público, bacheo y mantenimiento de espacios públicos',
                    voto: 'A Favor',
                    color: 'verde',
                    motivo: 'Los servicios públicos esenciales deben ser la primera prioridad del presupuesto municipal.',
                    fecha: 'Consultar acta de Cabildo'
                },
                {
                    id: 3,
                    tema: 'Fortalecimiento de servicios del Instituto Municipal de la Mujer',
                    voto: 'A Favor',
                    color: 'verde',
                    motivo: 'Las mujeres de Mineral de la Reforma requieren atención psicológica y apoyo integral accesible.',
                    fecha: 'Consultar acta de Cabildo'
                },
                {
                    id: 4,
                    tema: 'Reasignaciones presupuestales sin justificación suficiente',
                    voto: 'En Contra',
                    color: 'rojo',
                    motivo: 'El presupuesto debe responder a las necesidades reales de la ciudadanía, no a reasignaciones discrecionales.',
                    fecha: 'Consultar acta de Cabildo'
                }
            ]
        }
    }

    // Devuelve la clase CSS según el color del semáforo
    getColorClass(color) {
        const clases = {
            verde: 'semaforo-verde',
            rojo: 'semaforo-rojo',
            ambar: 'semaforo-ambar'
        };
        return clases[color] || '';
    }

    render() {
        return (
            <section className="section-padding bg-white" id="semaforo">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-8">
                            <div className="section-heading center-heading text-center mb-60">
                                <span className="subheading">La Voz en el Cabildo</span>
                                <h3 className="heading-title">Semáforo de Votaciones</h3>
                                <p>Cómo voté y por qué. Basado en las actas oficiales de sesión del Ayuntamiento de Mineral de la Reforma.</p>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12">
                            <div className="table-responsive">
                                <table className="table semaforo-table">
                                    <thead>
                                        <tr>
                                            <th>Tema</th>
                                            <th>Voto</th>
                                            <th>Por qué</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            this.state.votos.map((voto) => (
                                                <tr key={voto.id}>
                                                    <td>{voto.tema}</td>
                                                    <td>
                                                        <span className={`semaforo-badge ${this.getColorClass(voto.color)}`}>
                                                            {voto.voto}
                                                        </span>
                                                    </td>
                                                    <td>{voto.motivo}</td>
                                                </tr>
                                            ))
                                        }
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}

export default SemaforoVotaciones;
